<template>
    <div>
        <el-form-item :label="data.label" style="width:90%;">
          <el-col :span="20">
            <el-input :disabled="disabled" v-model="data.model" @input="saveDataToLocalStorage(data.model, data.name)" style="margin-left:4.5%" :class="verifyFields (data, validation) ? 'input-warning':''"/>
          </el-col>
          <el-col :span="3">
            <el-input :disabled="disabled" v-model="data.model2" @input="saveDataToLocalStorage(data.model2, data.label2)" type="number" :placeholder="data.label2" style="margin-left:32%" :class="verifyFieldsDoubleInput (data) ? 'input-warning':''"/>
          </el-col>
           <el-alert v-if="verifyFields (data, validation)" :title="`Falta completar: ${data.label}`" type="error" class="message-warning" :closable="false"/>
           <el-alert v-if="verifyFieldsDoubleInput (data)" :title="`Falta completar: ${data.label2}`" type="error" class="message-warning" :closable="false"/>
        </el-form-item>
    </div>
</template>

<script>
import { verifyFields, persistToNewProviderStorage, saveDataToLocalStorage } from '../helpers/utils.js'
export default {
  data () {
    return {
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    validation: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {},
  methods: {
    verifyFieldsDoubleInput (data) {
      return (data.model2.length === 0 && this.validation === false && data.required)
    },
    verifyFields,
    persistToNewProviderStorage,
    saveDataToLocalStorage
  }
}
</script>



// WEBPACK FOOTER //
// DoubleInput.vue?0798217e